export const BRAND_LABEL = { singular: 'Brand', plural: 'Brands' } as const;
